<template>
    <div>
        <ul role="tablist" class="panel bg--layer-light row">
            <li class="col-4 p-- text--center">
                <a id="friends-tab" data-toggle="tab" @click="activeTab = 'friends'"
                   role="tab" aria-controls="friends"
                   :class="['btn btn--block btn--tab', {'active': activeTab === 'friends'}]">
                    <span>Friends</span>
                </a>
            </li>

            <li class="col-4 p-- text--center">
                <a id="emails-tab" data-toggle="tab" role="tab" @click="activeTab = 'emails'"
                   aria-controls="emails"
                   :class="['btn btn--block btn--tab', {'active': activeTab === 'games'}]"><span>E-mail</span></a>
            </li>
        </ul>

        <div>
            <div id="friends" role="tabpanel" aria-labelledby="table-tab" v-show="activeTab === 'friends'"
                 class="tab-pane panel bg--layer-light">

                <template v-for="friend in friends" v-if="friends">
                    <div class="profile profile--horizontal profile--horizontal-xs profile--separator">
                        <figure class="profile__avatar profile__avatar--xs mr--sm">
                    <span class="profile__avatar__img">
                        <img :src="friend.avatar" :alt="friend.nick">
                    </span>
                        </figure>

                        <div class="profile__text">
                            <div class="profile__name">{{ friend.nick }}</div>
                        </div>

                        <div class="profile__buttons">
                            <button v-if="! hasInvited(friend.id)" @click="inviteFriend(friend.id)" class="btn btn--sm miw--80 btn--secondary">
                                Invite
                            </button>
                            <button disabled v-else class="btn btn--sm miw--80 btn--secondary">
                                Invited
                            </button>
                        </div>
                    </div>
                </template>

            </div>

            <div id="emails" role="tabpanel" aria-labelledby="table-tab" v-show="activeTab === 'emails'"
                 class="tab-pane panel bg--layer-light">
                <div class="mb--lg">
                    <input type="text" v-model="emails" :placeholder="'luke@starwars.com, leia@starwars.com'"
                           class="form-control mb--md">
                    <button type="button" @click="invite" class="btn btn--block btn--secondary">Invite</button>
                </div>

                <p class="text--center text--xs opacity--md">
                    <strong>You can specify up to five email addresses.</strong>
                </p>
            </div>
        </div>

        <modal show="false" type="error" ref="validationModal">
            <template v-slot:message>
                <div v-if="errors.any()">
                    <div v-for="error in errors.all()">{{ error }}</div>
                </div>
            </template>

            <template v-slot:buttons><span></span></template>
        </modal>

        <modal show="false" type="success" ref="successInvite">
            <template v-slot:message>
                Your invitations has been sent successfully!
            </template>

            <template v-slot:buttons><span></span></template>
        </modal>
    </div>
</template>

<script>
import {mapState} from "vuex";
import chatApi from "../api/chat";
import inviteApi from "../api/invite";
import Errors from "../util/Errors"

export default {
    name: "Invite",

    props: {
        channelId: {
            type: String,
            default: ''
        }
    },

    data: function () {
        return {
            activeTab: 'friends',
            friends: [],
            invitedFriends: [],
            emails: null,
            errors: new Errors()
        }
    },

    created() {
        this.loadFriends()
    },

    computed: {
        ...mapState('auth', [
            'user'
        ]),
    },

    methods: {
        async loadFriends() {
            try {
                let response = await chatApi.loadFriends()

                this.friends = response.data
            } catch (e) {

            }
        },

        hasInvited(id) {
            return this.invitedFriends.includes(id)
        },

        invite() {
            inviteApi.invite(this.emails)
                .then(() => {
                    this.$refs.successInvite.open()
                    this.emails = ''
                })
                .catch((error) => {
                    if (error.response.status === 422) {
                        this.errors.record(error.response.data.errors)
                        this.$refs.validationModal.open()
                    }
                })
        },

        inviteFriend(id) {
            inviteApi.inviteFriend(id, this.channelId)
                .then(() => {
                    this.$refs.successInvite.open()
                    this.invitedFriends.push(id)
                })
        },
    }
}
</script>
